import React, { PureComponent } from "react";
import { Form } from "antd";
import moment from "moment";

// svg для ссылок
import down_svg from "../../../images/down.svg";
import up_svg from "../../../images/up.svg";

// секции формы из добавления ТС
// import RegisterSign from '../../common/formSection/Fields/RegisterSign';
import AvtocodRegisterSign from "../../common/formSection/Fields/AvtocodRegisterSign";
import Main from "../../common/formSection/Main"; // Основные поля
import Additional from "../../common/formSection/Additional"; // Дополнительные поля

import Section2 from "../../common/formSection/section_2";
/* import Section3 from '../../common/formSection/section_3'; // todo next release */
/* import Section4 from '../../common/formSection/section_4'; // todo / this functionality will not be */
/* import Section5 from '../../common/formSection/section_5'; // todo next release */
import Section6 from "../../common/formSection/section_6";
import Section7 from "../../common/formSection/section_7";
/* import Section8 from '../../common/formSection/section_8'; // todo next release */
import Section9 from "../../common/formSection/section_9";
import Section10 from "../../common/formSection/section_10";
// стили секции лежат в addVehicleForm
import "./CardForm.css";

class CardForm extends PureComponent {
  render() {
    const {
      vehicle,
      getModelsByBrand,
      /*
      archiveVehicle,
      restoreVehicle,
      getVehicle,
      archivingError,
      archivingStatus,
      restoringError,
      restoringStatus,
      
      facilitiesTypes,
      interiorsTypes,
      transfersTypes,
      advertisingsTypes,
      appliancesTypes,
  */
      vehicleId,
      isEditable,
      validateField,
      typeForm,
      setFormFieldsAvtocod,
      handleShowMoreFields,
      moreFields,
      form,
      autoSearchStatus,
    } = this.props;
    const isAvtocodSearch = form.getFieldValue("avtocodSearch");
    return (
      <Form className="vehicleCardForm">
        <div className="addVehicleForm">
          <AvtocodRegisterSign
            form={form}
            disabled={!isEditable}
            validateField={validateField}
            typeForm={typeForm}
            setFormFieldsAvtocod={setFormFieldsAvtocod}
            isArchive={this.props.data.vehicleStatusKey === 'archive'}
            archievedAt={this.props.data.vehicleStatusKey === 'archive' &&
              this.props.data.archivedAt ? this.props.data.archivedAt : null}
          />
          <div
            className={
              typeForm !== "create" ||
                (typeForm === "create" &&
                  (!isAvtocodSearch ||
                    (isAvtocodSearch && autoSearchStatus === "success")))
                ? "block-show"
                : "block-hide"
            }
          >
            {/*
                {typeForm === 'create' ? (
                
              ) : (
                <div className="federalSignWrap">
                  <RegisterSign
                    form={this.props.form}
                    disabled={!isEditable}
                    isArchive={vehicle && vehicle.vehicleStatusKey === 'archive'}
                  />
                </div>
              )}
                <div className="federalSignWrap">
                <RegisterSign
                  form={this.props.form}
                  disabled={!isEditable}
                  isArchive={vehicle && vehicle.vehicleStatusKey === 'archive'}
                /> grid-auto-rows: 112px; 
                <AvtocodRegisterSign
                  form={this.props.form}
                  disabled={!isEditable}
                  validateField={validateField}
                />
              </div>*/}
            <Main
              fields={vehicle}
              form={form}
              disabled={!isEditable}
              getModelsByBrand={getModelsByBrand}
              vehicleId={vehicleId}
            />
            <div className={moreFields ? "block-show" : "block-hide"}>
              <Additional form={form} disabled={!isEditable} />
              <Section2 form={form} disabled={!isEditable} />
              {/* todo next release <Section3
                  fields={vehicle}
                  form={this.props.form}
                  disabledAll={!isEditable}
                />*/}
              {/* todo next release <Section5 form={this.props.form} disabled={!isEditable} /> */}
              <Section6 form={form} disabled={!isEditable} />
              <Section7 form={form} disabled={!isEditable} />
              {/* todo next release <Section8
                    fields={vehicle}
                    form={this.props.form}
                    disabledAll={!isEditable}
                    facilitiesTypes={facilitiesTypes}
                    interiorsTypes={interiorsTypes}
                    transfersTypes={transfersTypes}
                    advertisingsTypes={advertisingsTypes}
                    appliancesTypes={appliancesTypes}
                  />*/}
              <Section9
                form={form}
                disabled={!isEditable}
                vehicleId={vehicleId}
              />
              <Section10
                form={form}
                disabled={!isEditable}
                vehicleId={vehicleId}
              />
            </div>
            <span className="showMoreFields" onClick={handleShowMoreFields}>
              {moreFields ? "Скрыть параметры" : "Показать ещё параметры"}
              <img src={moreFields ? up_svg : down_svg} alt="svg" />
            </span>
          </div>
        </div>
      </Form>
    );
  }
}

class VehicleInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      default: {
        avtocodSearch: true,
        brandName: undefined,
        modelName: undefined,
        productionYear: undefined,
        colorName: undefined,
        engineCapacity: undefined,
        vehicleWeight: undefined,
        vehicleMaxWeight: undefined,
        steeringArrangement: undefined
      },
      moreFields: false
    };
    this.ref = React.createRef();
    this.defaultProfileData = {};
    this.flagInitEditing = false;
  }

  /* перенесено на уровень выше, чтобы при раскрытии всех полей, значения формы отрисованы */
  // ставит стейт показывать больше фильров
  handleShowMoreFields = () => {
    this.setState(state => ({ moreFields: !state.moreFields }));
  };

  componentDidMount() {
    this.initEditing();
  }
  componentDidUpdate(prevProps, prevState) {
    this.initEditing();
    //if (this.props.checkFormErrors) {
    //  this.props.checkFormErrors(this.props.name);
    //}
  }
  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  //
  initEditing = () => {
    let { isEditable, vehicle: dataProps, vehicleId } = this.props;
    if (
      !this.flagInitEditing &&
      isEditable &&
      ((dataProps && vehicleId > 0) || vehicleId === 0)
    ) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps && vehicleId !== 0) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item]
          };
        });
      }
      // add default value
      Object.keys(this.state.default).forEach(item => {
        if (!newEditData[item]) {
          newEditData[item] = this.state.default[item]
            ? { value: this.state.default[item] }
            : { value: undefined };
        }
      });
      this.setState({ data: newEditData }, () => {
        // проверить все поля на валидность
        if (this.formRef && vehicleId > 0) {
          this.formRef.validateFields((errors, values) => {
            this.changeValues(values);
          });
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };

  handleFieldsChange = values => {
    // Если есть серверные ошибки, и это поле изменилось, то удаляем ошибку из store
    if (this.props.createErrors) {
      Object.keys(values).forEach(name => {
        if (
          this.props.createErrors &&
          this.props.createErrors.data &&
          this.props.createErrors.data[name]
        ) {
          if (values[name].errors) {
            delete values[name].errors;
          }
          this.props.clearError(name);
        }
      });
    }

    this.setState(
      state => {
        return {
          data: {
            ...state.data,
            ...values
          }
        };
      },
      () => {
        this.changeValues(values);
      }
    );
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  //
  render() {
    const { isEditable } = this.props;
    const data = isEditable
      ? this.state.data
      : this.props.vehicle || this.defaultProfileData;
    return (
      <FormVehicleInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
        validateField={this.validateField}
        moreFields={this.state.moreFields}
        handleShowMoreFields={this.handleShowMoreFields}
      />
    );
  }
}

const FormVehicleInfo = Form.create({
  name: "formVehicleInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};

    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};
        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }

        let all = true;

        if (all) {
          obj[name] = Form.createFormField({
            ...(props.isEditable ? props.data[name] : {}),
            ...(props.isEditable ? err : {}),
            value: props.getValueByFieldName(
              name,
              props.isEditable ? props.data[name].value : props.data[name]
            )
          });
        }
      });
    return obj;
  },
  onValuesChange(props, values) { }
})(CardForm);

export default VehicleInfoData;
